import { render, staticRenderFns } from "./GarageRates.vue?vue&type=template&id=dd3020d4&scoped=true&"
import script from "./GarageRates.vue?vue&type=script&lang=js&"
export * from "./GarageRates.vue?vue&type=script&lang=js&"
import style0 from "./GarageRates.vue?vue&type=style&index=0&id=dd3020d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3020d4",
  null
  
)

export default component.exports